module.exports = __webpack_public_path__ + "img/dental_software.87a303f6.jpg";